import styled, { keyframes } from "styled-components";
import bgImage from "../../assets/leaderboard-bg.jpg";
import { Spinner } from "react-bootstrap";

export const BgImage = styled.div`
  background-image: url(${bgImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 150px 0px 250px 0px;
  background-color: rgba(0, 0, 0, 0.4);
  background-blend-mode: overlay;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 2px;
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid green;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RankContainer = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #333;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #ddd;
`;

export const FieldContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 2px 0;
  align-items: center;
  font-size: small;
`;

export const Label = styled.span`
  font-weight: bold;
  color: #333;
`;

/* New Divider */
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ddd;
  margin: 1px 0;
`;

export const Value = styled.span<{ color?: string }>`
  color: ${(props) =>
    props.color?.startsWith("RGB")
      ? props.color.replace("RGB", "rgb")
      : "#444"};
  font-weight: ${(props) => (props.color ? "bold" : "normal")};
  margin-left: auto;
  font-weight: bold;
`;

const fade = keyframes`
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
`;

const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 1; }
`;

export const LoadingLogo = styled.img`
  width: 120px;
  height: auto;
  animation: ${breathe} 1.5s ease-in-out infinite;
`;

export const SpinnerWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
`;

export const CenterLogo = styled.img`
  position: absolute;
  width: 120px;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${fade} 1.5s ease-in-out infinite;
`;

export const SpinnerOverlay = styled(Spinner)`
  position: absolute;
  width: 145px;
  height: 145px;
  top: 0;
  left: 0;

  opacity: 0.5;
  border-width: 0.25em;
  border-right-color: transparent;
  border-top-color: green; /* Your custom color */
  border-bottom-color: green;
  border-left-color: green;
`;
